(function ($) {
  $(document).ready(function () {
    initProductAddForms();
    disableButtons();
    initProductGallery();
  });

  function initProductAddForms() {
    $('form[action*="/cart/add"]').each(function () {
      syncAddToCartButtonForForm($(this));
    });
    $(document).on('change', 'form[action*="/cart/add"] select[name="id"]', function () {
      syncAddToCartButtonForForm($(this).closest('form'));
    });
  }

  function syncAddToCartButtonForForm($form) {
    var $select = $form.find('select[name="id"]');
    var $btn = $form.find('[type="submit"]');
    if (!$select.length || !$btn.length) return;

    var $selected = $select.find('option:selected');
    var available = $selected.attr('data-available') === 'true';

    var $scope = $form.closest('[data-add-label]');
    var addLabel = $scope.attr('data-add-label') || 'Add To Bag';
    var soldOutLabel = $scope.attr('data-sold-out-label') || 'Sold Out';

    $btn.attr('udesly-shopify-disabled', available ? 'false' : 'true');
    $btn.prop('disabled', !available);
    $btn.val(available ? addLabel : soldOutLabel);
  }

  function disableButtons() {
    $.each($('[udesly-shopify-disabled]'), function () {
      var raw = $(this).attr('udesly-shopify-disabled');
      if (raw === undefined || raw === null) return;
      var shouldBeDisabled = raw.trim() === 'true';
      $(this).prop('disabled', shouldBeDisabled);
    });
  }

  var currentIndex = 1;

  function initProductGallery() {
    var gallery = $('[udesly-data="product-gallery"]');
    if (!gallery.length) {
      return;
    }
    var triggers = $('[udesly-shopify-product-lb-t]');
    var thumbnails = $('[udesly-shopify-product-thumbnail]');

    var currentThumbClasses = $('[udesly-shopify-product-thumbnail="1"]').attr('class');
    var notActiveThumbClasses = '';
    if(thumbnails.length > 1) {
      notActiveThumbClasses = $('[udesly-shopify-product-thumbnail="2"]').attr('class');
    }

    var maxIndex = triggers.length;

    function goRight() {
      if (currentIndex == maxIndex) {
        currentIndex = 1;
      }else {
        currentIndex++;
      }
      changeLightboxTrigger(currentIndex);
      changeThumbnailsClasses(currentIndex, currentThumbClasses, notActiveThumbClasses);
    }

    function goLeft() {
      if (currentIndex == 1) {
        currentIndex = maxIndex;
      }else {
        currentIndex--;
      }
      changeLightboxTrigger(currentIndex);
      changeThumbnailsClasses(currentIndex, currentThumbClasses, notActiveThumbClasses);
    }

    function goToIndex(index) {
      currentIndex = index;
      changeLightboxTrigger(currentIndex);
      changeThumbnailsClasses(currentIndex, currentThumbClasses, notActiveThumbClasses);
      changeDot();
    }

    function changeDot() {
      $(gallery.find('.w-slider-dot').get(currentIndex-1)).trigger('tap');
    }

    $('.w-slider-arrow-right').on('click', function() {
      goRight();
    });

    $('body').on('click', '.w-lightbox-left', function() {
      if ($(this).hasClass('w-lightbox-inactive')) {
        return;
      }
      goLeft();
      changeDot();
    });

    $('.w-slider-arrow-left').on('click', function() {
      goLeft();
    });

    $('body').on('click', '.w-lightbox-right', function() {
      if ($(this).hasClass('w-lightbox-inactive')) {
        return;
      }
      goRight();
      changeDot();
    });

    $('body').on('click', '[udesly-data="thumbnail-container"] div', function() {
      var newIndex = $(this).index() + 1;
      goToIndex(newIndex);
    });

    $('body').on('click', '.w-lightbox-item', function () {
      var newIndex = $(this).index() + 1;
      goToIndex(newIndex);
    });

    gallery.find('.w-slider-dot').on('click', function() {
      var newIndex = $(this).index() + 1;
      goToIndex(newIndex);
    });
  }


  function changeLightboxTrigger(index) {
    $('[udesly-shopify-product-lb-t]').hide();
    $('[udesly-shopify-product-lb-t="'+ index +'"]').show();
  }

  function changeThumbnailsClasses(index, currentClasses, notCurrentClasses) {
    $('[udesly-shopify-product-thumbnail]').attr('class', notCurrentClasses);
    $('[udesly-shopify-product-thumbnail="'+ index +'"]').attr('class', currentClasses);
  }


})(jQuery);
